import React from "react";

export const Markets = (props) => {
  const data = props.data || {};
  return (
    <div id="markets">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <span className="eyebrow">Export</span>
            <h2>{data.title}</h2>
            <p>{data.paragraph}</p>
          </div>
          <div className="col-md-6">
            <ul className="market-list">
              {data.regions
                ? data.regions.map((r, i) => (
                    <li key={`${r}-${i}`}>
                      <i className="fa fa-globe"></i> {r}
                    </li>
                  ))
                : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
